export const MAIN_HEADER_HEIGHT = 56
